/**
 * Universal address mapper - handles ALL address mapping scenarios
 * Works with:
 * - Location API responses (new addresses)
 * - Customer address entities (saved addresses)
 * - Cart addresses (restored carts)
 * - Any address object from any source
 * 
 * Provides BOTH PostCode and Postcode for backward compatibility
 */
export function mapAddress(address) {
    if (!address) return null;
    
    return {
        LocationProvider: address.LocationProvider,
        LocationProviderIDX: address.LocationProviderIDX,
        BuildingName: address.BuildingName ?? '',
        AddressType: address.AddressType ?? '',
        UnitType: address.UnitType ?? '',
        UnitTypeExtra: address.UnitTypeExtra ?? '',
        Number: address.Number ?? '',
        NumberPre: address.NumberPre ?? '',
        NumberPost: address.NumberPost ?? '',
        StreetName: address.StreetName ?? '',
        StreetType: address.StreetType ?? '',
        State: address.State ?? '',
        Suburb: address.Suburb ?? '',
        Country: address.Country ?? 'New Zealand',
        Latitude: address.Latitude ?? 0,
        Longitude: address.Longitude ?? 0,
        City: address.City ?? '',
        
        PostCode: address.PostCode ?? address.Postcode ?? '',
        Postcode: address.PostCode ?? address.Postcode ?? '', //backward compatibility
        
        Lines: address.Lines ?? [
            [
                `${address.NumberPre}${address.NumberPre ? '/' : ''}${address.Number}${address.NumberPost}`,
                address.StreetName,
                address.StreetType,
            ].join(' ').trim(),
            [
                address.BuildingName,
                address.Suburb,
            ].join(' ').trim(),
        ].filter(line => Boolean(line)),
        
        Formatted: address.Formatted ?? '',
        FormattedOriginal: address.FormattedOriginal ?? '',
        AddressUUID: address.UUID ?? address.AddressUUID,
        Description: address.Description ?? address.Formatted ?? '',
        IsDefault: address.IsDefault ?? (address.Rank == 1),
        availableServices: address.availableServices ?? {},
    }
}

/**
 * Helper to get postcode value safely from any address object
 */
export function getPostcode(address) {
    return address?.PostCode ?? address?.Postcode ?? '';
}

/**
 * Create API payload address object with correct field names
 */
export function toApiAddress(address) {
    if (!address) return null;
    
    return {
        City: address.City ?? '',
        Country: address.Country ?? '',
        PostCode: getPostcode(address),
        Postcode: address.PostCode ?? address.Postcode ?? '', //backward compatibility
        Lines: address.Lines ?? [''],
        LocationProvider: address.LocationProvider,
        LocationProviderIDX: address.LocationProviderIDX,
    }
}